<template>
    <div v-if="visible">
        <b-modal
            visible
            size="lg"
            :title="$t('PPDbChangeInfo.Title')"
            no-close-on-backdrop
            no-close-on-esc
            @hidden="close"
        >
            <div v-if="changedFields.length === 0" class="text-center text-muted py-3">
                {{ $t('PPDbChangeInfo.NoChanges') }}
            </div>

            <b-table
                v-else
                :fields="comparisonFields"
                :items="changedFields"
                bordered
                striped
                small
                responsive
            >
                <template #cell(currentValue)="{ value }">
                    <span class="text-muted">{{ value }}</span>
                </template>
                <template #cell(requestedValue)="{ value }">
                    <span class="font-weight-bold text-primary">{{ value }}</span>
                </template>
            </b-table>

            <template #modal-footer>
                <b-button
                    v-if="item && item.requestStatus === 'D'"
                    variant="secondary"
                    @click="$emit('undoDiscard', item)"
                >
                    {{ $t('PPDbChangeInfo.UndoDiscard') }}
                </b-button>
                <b-button variant="secondary" @click="close">
                    {{ $t('Shared.Close') }}
                </b-button>
                <b-button
                    v-if="item && item.requestStatus === 'N'"
                    variant="secondary"
                    @click="$emit('discard', item)"
                >
                    {{ $t('PPDbChangeInfo.Discard') }}
                </b-button>
                <b-button
                    v-if="item && item.requestStatus === 'N'"
                    variant="primary"
                    @click="$emit('change', item)"
                >
                    {{ $t('PPDbChangeInfo.Change') }}
                </b-button>
                
            </template>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'PatientPortalChangeInfoDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        item: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            comparisonFields: [
                {
                    key: 'field',
                    label: this.$t('Shared.Field'),
                    class: 'text-left font-weight-bold',
                    thStyle: { width: '30%' }
                },
                {
                    key: 'currentValue',
                    label: this.$t('PPDbChangeInfo.PreviousValue'),
                    class: 'text-left',
                    thStyle: { width: '35%' }
                },
                {
                    key: 'requestedValue',
                    label: this.$t('PPDbChangeInfo.RequestedValue'),
                    class: 'text-left',
                    thStyle: { width: '35%' }
                }
            ],
            fieldPairs: [
                { key: 'lastName',   label: this.$t('Shared.LastName') },
                { key: 'firstName',  label: this.$t('Shared.FirstName') },
                { key: 'title',      label: this.$t('PPDbChangeInfo.Salutation') },
                { key: 'address1',   label: this.$t('Shared.Address1') },
                { key: 'address2',   label: this.$t('Shared.Address2') },
                { key: 'zip',        label: this.$t('Shared.Zip') },
                { key: 'city',       label: this.$t('Shared.City') },
                { key: 'state',      label: this.$t('Shared.State') },
                { key: 'country',    label: this.$t('Shared.Country') },
                { key: 'dayPhone',   label: this.$t('Shared.DayPhone') },
                { key: 'nightPhone', label: this.$t('Shared.NightPhone') },
                { key: 'cellPhone',  label: this.$t('Shared.CellPhone') },
                { key: 'cellCompany', label: this.$t('PPDbChangeInfo.CellCarrier') },
                { key: 'email',      label: this.$t('Shared.Email') }
            ]
        };
    },
    computed: {
        changedFields() {
            if (!this.item) return [];
            return this.fieldPairs
                .filter(({ key }) => {
                    const oldVal = (this.item[`${key}Old`] || '').trim();
                    const newVal = (this.item[`${key}New`] || '').trim();
                    return oldVal !== newVal;
                })
                .map(({ key, label }) => ({
                    field: label,
                    currentValue: this.item[`${key}Old`] || '',
                    requestedValue: this.item[`${key}New`] || ''
                }));
        }
    },
    methods: {
        close() {
            this.$emit('close');
        }
    }
};
</script>
